export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 're-men-tui-jian',
    name: '热门推荐',
    slug: 're-men-tui-jian',
    icon: 'ri-fire-line',
    description: '精选最受欢迎的美女短视频内容，每日热门排行实时更新，发现最火爆的颜值博主和精彩视频',
  },
  {
    id: 'yan-zhi-zhu-bo',
    name: '颜值主播',
    slug: 'yan-zhi-zhu-bo',
    icon: 'ri-star-line',
    description: '汇聚全网高颜值主播，甜美女神、气质御姐、清纯学妹，各类美女博主直播互动精彩不断',
  },
  {
    id: 'wu-dao-cai-yi',
    name: '舞蹈才艺',
    slug: 'wu-dao-cai-yi',
    icon: 'ri-music-line',
    description: '热门舞蹈挑战、才艺表演秀，从古典舞到街舞，从唱歌到乐器，才艺美女的精彩舞台',
  },
  {
    id: 'chuan-da-shi-shang',
    name: '穿搭时尚',
    slug: 'chuan-da-shi-shang',
    icon: 'ri-shirt-line',
    description: '时尚穿搭分享、美妆教程、潮流造型展示，跟随时尚博主学习最in的穿搭技巧与妆容秘诀',
  },
  {
    id: 'sheng-huo-ri-chang',
    name: '生活日常',
    slug: 'sheng-huo-ri-chang',
    icon: 'ri-heart-line',
    description: '美女博主的日常生活Vlog，美食探店、旅行记录、健身日常，感受真实有趣的生活方式',
  },
  {
    id: 'zui-xin-shang-xian',
    name: '最新上线',
    slug: 'zui-xin-shang-xian',
    icon: 'ri-rocket-line',
    description: '最新入驻平台的优质博主和最新上线的精彩视频内容，第一时间发现新鲜好看的美女短视频',
  },
];